import React, { useState } from 'react';
import {
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  FormHelperText,
  Grid,IconButton
} from '@mui/material';
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

export const SchedulingRouteForm = () => {
  const [formData, setFormData] = useState({
    admissionNo: '',
    studentFirstName: '',
    studentLastName: '',
    fatherName: '',
    fatherPhone: '',
    address: '',
    gender: '',
    distance: '',
    feePayment: '',
    feeDue: '',
    busNumber: '',
    route: '',
    pickup: '',
    drop: '',
    phone: '',
    email: '',
  });

  const [errors, setErrors] = useState({});
  const [searchError, setSearchError] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const navigate=useNavigate()

  const genderOptions = [
    { value: 'Male', label: 'Male' },
    { value: 'Female', label: 'Female' },
    { value: 'Other', label: 'Other' },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setIsSearching(true);
    setSearchError('');

    // Simulate fetching data based on admission number
    const fetchedData = mockSearch(formData.admissionNo);

    if (fetchedData) {
      setFormData(fetchedData);
    } else {
      setSearchError('No record found for this Admission No');
    }
    setIsSearching(false);
  };

  const mockSearch = (admissionNo) => {
    // Mock data for testing with dummy admission numbers
    const mockDatabase = [
      {
        admissionNo: '12345',
        studentFirstName: 'John',
        studentLastName: 'Doe',
        fatherName: 'David Doe',
        fatherPhone: '1234567890',
        address: '123 Main St',
        gender: 'Male',
        distance: '10',
        feePayment: 'Paid',
        feeDue: '0',
        busNumber: '123',
        route: 'Route 1',
        pickup: 'Location A',
        drop: 'Location B',
        phone: '1234567890',
        email: 'john.doe@example.com',
      },
      {
        admissionNo: '67890',
        studentFirstName: 'Jane',
        studentLastName: 'Smith',
        fatherName: 'Robert Smith',
        fatherPhone: '9876543210',
        address: '456 Elm St',
        gender: 'Female',
        distance: '15',
        feePayment: 'Unpaid',
        feeDue: '100',
        busNumber: '456',
        route: 'Route 2',
        pickup: 'Location C',
        drop: 'Location D',
        phone: '9876543210',
        email: 'jane.smith@example.com',
      },
    ];

    return mockDatabase.find((record) => record.admissionNo === admissionNo);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.studentFirstName) newErrors.studentFirstName = 'First Name is required';
    if (!formData.studentLastName) newErrors.studentLastName = 'Last Name is required';
    if (!formData.fatherName) newErrors.fatherName = 'Father\'s Name is required';
    if (!formData.fatherPhone) newErrors.fatherPhone = 'Father\'s Phone Number is required';
    if (!/^\d{10}$/.test(formData.fatherPhone)) newErrors.fatherPhone = 'Invalid Phone Number';
    if (!formData.address) newErrors.address = 'Address is required';
    if (!formData.gender) newErrors.gender = 'Gender is required';
    if (!formData.distance) newErrors.distance = 'Distance is required';
    if (!formData.feePayment) newErrors.feePayment = 'Fee Payment is required';
    if (!formData.feeDue) newErrors.feeDue = 'Fee Due is required';
    if (!formData.busNumber) newErrors.busNumber = 'Bus Number is required';
    if (!formData.route) newErrors.route = 'Route is required';
    if (!formData.pickup) newErrors.pickup = 'Pickup Location is required';
    if (!formData.drop) newErrors.drop = 'Drop Location is required';
    if (!formData.phone) newErrors.phone = 'Phone Number is required';
    if (!/^\d{10}$/.test(formData.phone)) newErrors.phone = 'Invalid Phone Number';
    if (!formData.email) newErrors.email = 'Email is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      console.log('Form submitted:', formData);
      alert('Registration successful!');
      setFormData({
        admissionNo: '',
        studentFirstName: '',
        studentLastName: '',
        fatherName: '',
        fatherPhone: '',
        address: '',
        gender: '',
        distance: '',
        feePayment: '',
        feeDue: '',
        busNumber: '',
        route: '',
        pickup: '',
        drop: '',
        phone: '',
        email: '',
      });
    }
  };

  return (
    <Box
      style={{
        margin: '60px 20px',
        padding: '10px',
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        maxHeight: '100vh',
        overflow: 'hidden',
      }}
    >
         <Box display="flex" alignItems="center" sx={{marginBottom:2}}>
                            
                                  <IconButton onClick={() => navigate('/SchedulingRouteList')} sx={{ color: '#2e2a54' }}>
                                    <KeyboardBackspaceIcon fontSize="medium" />
                                  </IconButton>
                                  <Typography variant="h4" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        Scheduling Route Registration Form
                                </Typography>
                              
                            
                              
       </Box>
      

      {/* Search Input and Button */}
      <Box sx={{ marginBottom: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={9}>
            <TextField
              fullWidth
              label="Enter Admission No"
              name="admissionNo"
              value={formData.admissionNo}
              onChange={handleInputChange}
              error={!!searchError}
              helperText={searchError}
              sx={{ width: '30%' }} // Reduced width here
            />
          {/* </Grid>
          <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'flex-end' }}> */}
            <Button
              variant="contained"
              color="primary"
              sx={{
                // width: '50%', // Reduced width
                height: '50px', // Increased height
                backgroundColor: '#1976d2', // Custom button color
                marginLeft:'10px'
              }}
              onClick={handleSearch}
              disabled={isSearching}
            >
              {isSearching ? 'Searching...' : 'Search'}
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* Form */}
      <form onSubmit={handleSubmit}>
        <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap="20px">
          <TextField
            fullWidth
            label="Student First Name"
            name="studentFirstName"
            value={formData.studentFirstName}
            onChange={handleInputChange}
            error={!!errors.studentFirstName}
            helperText={errors.studentFirstName}
          />

          <TextField
            fullWidth
            label="Student Last Name"
            name="studentLastName"
            value={formData.studentLastName}
            onChange={handleInputChange}
            error={!!errors.studentLastName}
            helperText={errors.studentLastName}
          />

          <TextField
            fullWidth
            label="Father's Name"
            name="fatherName"
            value={formData.fatherName}
            onChange={handleInputChange}
            error={!!errors.fatherName}
            helperText={errors.fatherName}
          />

          <TextField
            fullWidth
            label="Father's Phone"
            name="fatherPhone"
            value={formData.fatherPhone}
            onChange={handleInputChange}
            error={!!errors.fatherPhone}
            helperText={errors.fatherPhone}
          />

          <TextField
            fullWidth
            label="Address"
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            error={!!errors.address}
            helperText={errors.address}
          />

          <FormControl fullWidth error={!!errors.gender}>
            <InputLabel htmlFor="gender">Gender</InputLabel>
            <Select
              id="gender"
              name="gender"
              value={formData.gender}
              onChange={handleInputChange}
              label="Gender"
            >
              {genderOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{errors.gender}</FormHelperText>
          </FormControl>

          <TextField
            fullWidth
            label="Distance"
            name="distance"
            value={formData.distance}
            onChange={handleInputChange}
            error={!!errors.distance}
            helperText={errors.distance}
          />

          <TextField
            fullWidth
            label="Fee Payment"
            name="feePayment"
            value={formData.feePayment}
            onChange={handleInputChange}
            error={!!errors.feePayment}
            helperText={errors.feePayment}
          />

          <TextField
            fullWidth
            label="Fee Due"
            name="feeDue"
            value={formData.feeDue}
            onChange={handleInputChange}
            error={!!errors.feeDue}
            helperText={errors.feeDue}
          />

          <TextField
            fullWidth
            label="Bus Number"
            name="busNumber"
            value={formData.busNumber}
            onChange={handleInputChange}
            error={!!errors.busNumber}
            helperText={errors.busNumber}
          />

          <TextField
            fullWidth
            label="Route"
            name="route"
            value={formData.route}
            onChange={handleInputChange}
            error={!!errors.route}
            helperText={errors.route}
          />

          <TextField
            fullWidth
            label="Pickup Location"
            name="pickup"
            value={formData.pickup}
            onChange={handleInputChange}
            error={!!errors.pickup}
            helperText={errors.pickup}
          />

          <TextField
            fullWidth
            label="Drop Location"
            name="drop"
            value={formData.drop}
            onChange={handleInputChange}
            error={!!errors.drop}
            helperText={errors.drop}
          />

          <TextField
            fullWidth
            label="Phone"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            error={!!errors.phone}
            helperText={errors.phone}
          />

          <TextField
            fullWidth
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            error={!!errors.email}
            helperText={errors.email}
          />
        </Box>

        {/* Register Button */}
        <Grid container justifyContent="right" sx={{ marginTop: 4 }}>
          <Grid item>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{
                padding: '10px 20px',
                backgroundColor: '#1976d2', // Custom button color
              }}
            >
              Register 
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};